// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_reserveLimit/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_reserveLimit/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_reserveLimit/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_reserveLimit/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_reserveLimit/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  // select:住診老師,小老師,自學的所有療程項目(參數是:SYS_COACHES)
  GetAllTreatment(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/SelectData',
      params,
    });
  },
  // select:語言
  GetLanguage(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Language/SelectData',
      params,
      transformResponse: [(res) => {
        const { data, code } = JSON.parse(res);
        return { code, data: data ? data.sort((a, b) => b.sort - a.sort).reverse() : data };
      }],
    });
  },
  // select:軟體
  GetSoftware(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Software/Load',
      params,
    });
  },
};
